import React, { createContext, useState } from "react";

interface EditActionContextType {  
  backendFormErrors: any;
  setBackendFormErrors: (backendFormErrors: any) => void;  
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  element: any;
  setElement: (element: any) => void;
  selectedLang: string;
  setSelectedLang: (selectedLang: string) => void;
  attributes: any[],
  setAttributes: (attributes: any) => void;
  commercePrice: number
  setCommercePrice: (price: number) => void
  shippingPercentage: number
  setShippingPercentage: (percentage: number) => void;
  commissionPercentage: number
  setCommissionPercentage: (percentage: number) => void;
  adjustmentError: any;
  setAdjustmentError: (error: any) => void;
}

export const EditActionContext = createContext<EditActionContextType>({  
  backendFormErrors: {},
  setBackendFormErrors: () => {},
  showModal: false,
  setShowModal: () => {},
  element: null,
  setElement: () => {},
  selectedLang: "",
  setSelectedLang: () => {},
  attributes: [],
  setAttributes: () => {},
  commercePrice: 0,
  setCommercePrice: () => {},
  shippingPercentage: 0,
  setShippingPercentage: () => {},
  commissionPercentage: 0,
  setCommissionPercentage: () => {},
  adjustmentError: null,
  setAdjustmentError: () => {},
});

interface EditActionProviderProps {
  children: React.ReactNode;
}

export const EditActionProvider: React.FC<EditActionProviderProps> = ({
  children,
}) => {  
  const [backendFormErrors, setBackendFormErrors] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [element, setElement] = useState<any>(null);
  const [selectedLang, setSelectedLang] = useState<string>("");
  const [attributes, setAttributes] = useState<any[]>([]);
  const [commercePrice, setCommercePrice] = useState<number>(0);
  const [shippingPercentage, setShippingPercentage] = useState<number>(0);
  const [commissionPercentage, setCommissionPercentage] = useState<number>(0);
  const [adjustmentError, setAdjustmentError] = useState<any>(null);

  const value = {    
    backendFormErrors,
    setBackendFormErrors,
    showModal,
    setShowModal,
    element,
    setElement,
    selectedLang,
    setSelectedLang,
    attributes,
    setAttributes,
    commercePrice,
    setCommercePrice,
    shippingPercentage,
    setShippingPercentage,
    commissionPercentage,
    setCommissionPercentage,
    adjustmentError,
    setAdjustmentError,
  };
  return (
    <EditActionContext.Provider value={value}>      
      {children}
    </EditActionContext.Provider>
  );
};
